import React, { useState, useEffect, useContext } from "react";
import { Link, Redirect, useLocation } from "react-router-dom";

import { Icon, Select, Switch } from "antd";
import axios from "axios";

import { GlobalContext } from "../../app/providers/GlobalState";

import Notas from "./Notas/Notas";
import Conceitos from "./Conceitos/Conceitos";
import Bncc from "./Bncc/Bncc";
import Acessos from "../../Geral/Acessos/Acessos";

import SelectDisciplinas from "../Diario/componentes/SelectDisciplinas";

const { Option } = Select;
const Aproveitamento = ({ match }) => {
    const context = useContext(GlobalContext);
    const location = useLocation();

    const [parametros, setParametros] = useState([]);
    const [disciplinas, setDisciplinas] = useState([]);
    const [disciplinaId, setDisciplinaId] = useState(() => {
        const stored = localStorage.getItem("disciplina_aproveitamento");
        return stored ? Number(stored) : undefined;
    });
    const [estruturaId, setEstruturaId] = useState(undefined);
    const [tipo, setTipo] = useState("");
    const [periodo, setPeriodo] = useState([]);
    const [redirect, setRedirect] = useState(false);
    const [redirectLink, setRedirectLink] = useState("");
    const [parametrosDisciplinaId, setParametrosDisciplinaId] = useState(null);
    const [loadingParametros, setLoadingParametros] = useState(false);

    const listarParametros = async discId => {
        setLoadingParametros(true);

        try {
            const response = await axios.get("/api/aproveitamento/listar-estruturas-avaliacao", {
                params: { disciplinaId: discId }
            });

            const novosParametros = response.data || [];
            setParametros(novosParametros);
            setParametrosDisciplinaId(discId);

            if (novosParametros.length === 1) {
                const estrutura = novosParametros[0];
                setEstruturaId(estrutura.id);
                setTipo(estrutura.tipo);
                setPeriodo(estrutura.periodo);
                return;
            }

            // Se tinhas uma estrutura selecionada, valida se ainda existe nesta disciplina:
            setEstruturaId(prev => {
                const existe = novosParametros.some(x => x.id === prev);
                if (!existe) {
                    setTipo("");
                    setPeriodo([]);
                    return undefined;
                }
                // Se existe, mantém e garante tipo/periodo consistentes
                const atual = novosParametros.find(x => x.id === prev);
                if (atual) {
                    setTipo(atual.tipo);
                    setPeriodo(atual.periodo);
                }
                return prev;
            });
        } catch (error) {
            if (error.response?.status === 401) {
                setRedirectLink("/login");
                setRedirect(true);
            }
        } finally {
            setLoadingParametros(false);
        }
    };

    const handleSelectDisciplinas = value => {
        setDisciplinaId(value);
    };

    const carregarDisciplinas = () => {
        axios({
            method: "get",
            url: "/api/aulas/listar-turma-disciplinas",
            params: {
                turmaId: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                setDisciplinas(response.data);
            })
            .catch(error => {});
    };

    const handleChangeSelect = value => {
        if (value) {
            setEstruturaId(value);
            setTipo(parametros.find(x => x.id === value).tipo);
            setPeriodo(parametros.find(x => x.id === value).periodo);
        } else {
            setEstruturaId(undefined);
            setTipo("");
            setPeriodo([]);
        }
    };

    const turmas = () => {
        axios({
            method: "get",
            url: "/api/gerir-turma/carregar-header-info",
            params: {
                cursoid: disciplinaId
            }
        })
            .then(response => {
                const dados = response.data.multisseriados.map(dado => ({
                    ...dado,
                    value: dado.disciplina.id,
                    label: dado.nome,
                    turmaId: dado.disciplina.id,
                    cursoId: dado.id
                }));

                // Define a opção inicial selecionada com base no localStorage
                const codigoCurso = Number(localStorage.getItem("codigo_curso"));
                const inicialSelecionada = dados.filter(x => x.id === codigoCurso).map(x => x.disciplina.id);

                localStorage.setItem("disciplina_aproveitamento", inicialSelecionada[0]);
                setDisciplinaId(inicialSelecionada[0]);
            })
            .catch(error => {
                if (error.response?.status === 401) {
                    // setRedirectLink("/login");
                    // setRedirect(true);
                }
            });
    };

    const montarBotaoVoltar = () => {
        if (localStorage.getItem("opcao_voltar") != null) {
            const opcaoInfo = JSON.parse(localStorage.getItem("opcao_voltar"));
            return (
                <Link
                    to={opcaoInfo.link_voltar_curso ? opcaoInfo.link_voltar_curso : opcaoInfo.link_voltar}
                    className="botao-secundario botao-secundario-redondo"
                    onClick={() => opcaoInfo.id_curso && localStorage.setItem("codigo_curso", opcaoInfo.id_curso)}
                    style={{ marginRight: 10, display: "flex", justifyContent: "center", alignItems: "center" }}
                >
                    <Icon type="arrow-left" />
                </Link>
            );
        }
    };

    useEffect(() => {
        carregarDisciplinas();
        if (localStorage.getItem("aproveitamento")) {
            const info = JSON.parse(localStorage.getItem("aproveitamento"));

            setEstruturaId(info.estrutura);
            setTipo(info.tipo);
            setPeriodo(info.periodo);
            localStorage.removeItem("aproveitamento");
        }
        if (disciplinaId !== undefined) turmas();
    }, [location.pathname]);

    useEffect(() => {
        if (disciplinaId !== undefined) {
            localStorage.setItem("disciplina_aproveitamento", disciplinaId);

            // MUITO IMPORTANTE: limpa para evitar render com estrutura antiga
            setEstruturaId(undefined);
            setTipo("");
            setPeriodo([]);
            setParametros([]);
            setParametrosDisciplinaId(null);

            listarParametros(disciplinaId);
        }
    }, [disciplinaId]);

    if (redirect) return <Redirect to={redirectLink} />;

    localStorage.setItem("vista_pautas", true);

    const acesso = context.acessos?.find(x => x.func === 21);

    const estruturaValida =
        !!disciplinaId && parametrosDisciplinaId === disciplinaId && !!estruturaId && parametros.some(p => p.id === estruturaId);

    const prontoParaRenderFilhos = !loadingParametros && estruturaValida;

    return (
        <>
            <Acessos funcionalidadeId={21} />
            <div className="container container-body">
                <div className="turma-visao-geral">
                    <div className="controlos controlos-fundo">
                        <div className="bloco-esquerda">
                            <SelectDisciplinas
                                disciplinaId={disciplinaId}
                                disciplinas={disciplinas}
                                onChange={handleSelectDisciplinas}
                                visible
                            />
                            {parametros.length > 1 && (
                                <Select
                                    placeholder="Selecionar estrutura"
                                    value={estruturaId}
                                    allowClear={true}
                                    onChange={handleChangeSelect}
                                >
                                    {parametros.map(parametro => (
                                        <Option key={parametro.id} value={parametro.id}>
                                            {parametro.nome}
                                        </Option>
                                    ))}
                                </Select>
                            )}
                            {periodo && tipo && (
                                <div style={{ display: "flex", gap: 10 }}>
                                    <span style={{ display: "block", lineHeight: "initial" }}>
                                        Periodo Letivo: <strong>{periodo}</strong>
                                    </span>
                                    <span style={{ display: "block", lineHeight: "initial" }}>
                                        Tipo: <strong>{tipo}</strong>
                                    </span>
                                </div>
                            )}
                        </div>
                        <div className="bloco-direita">{montarBotaoVoltar()}</div>
                    </div>
                    {prontoParaRenderFilhos && tipo === "Notas" && <Notas estruturaId={estruturaId} tipo={tipo} />}
                    {prontoParaRenderFilhos && (tipo === "Conceitos" || tipo === "Modulos") && (
                        <Conceitos estruturaId={estruturaId} periodo={periodo} tipo={tipo} />
                    )}
                    {tipo === "BNCC" && <Bncc estruturaId={estruturaId} periodo={periodo} tipo={tipo} />}
                </div>
            </div>
        </>
    );
};
export default Aproveitamento;
